import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'RtGtmImpressionSentinel',
  props: {
    impressionId: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})